import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { AgenciesQuery as AgenciesQueryType, AgenciesQueryVariables } from "./__generated__/AgenciesQuery";

const AgenciesQuery = loader("./AgenciesQuery.gql");

type AgenciesQueryProviderType = (props: {
  children: (data: AgenciesQueryType) => ReactNode;
  variables?: AgenciesQueryVariables;
}) => ReactElement;

export const AgenciesQueryProvider: AgenciesQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<AgenciesQueryType, AgenciesQueryVariables>(AgenciesQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
